var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('ab-header'),_c('div',{staticClass:"g-bx"},[_c('div',{staticClass:"g-cnt"},[_c('router-view')],1)]),_c('ab-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }